<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">TWO-FACTOR AUTHENTICATION</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>
    <div class="container-center lg animated fadeIn">
      <div class="text-center">
        <p>
          Greatly increase security by requiring both your password and another
          form of authentication
        </p>
      </div>
      <div class="panel panel-filled">
        <div class="panel-body" v-if="!status2fa">
          <h3 class="text-center">
            Status :
            <span class="text-accent">DISABLED</span>
          </h3>
          <div class="m-t-xl">
            <h4>How to Enable Two-Factor Authentication</h4>
            <h3 class="mt-20">
              1.
              <small>Download Google Authenticator on your mobile device</small>
            </h3>
            <p class="text-center">
              <img src="@/assets/google-authenticator.png" class="app" />
              <br />Google Authenticator
            </p>
            <p class="text-center">
              <img src="@/assets/download-apple-store.png" class="app" />
              <img src="@/assets/download-google-store.png" class="app" />
            </p>
            <h3 class="mt-20">
              2.
              <small>Use Google Authenticator to scan the QRCode</small>
            </h3>
            <p>
              If you are unable to scan the QR code, please enter this code
              manually into the app.
            </p>
            <div class="text-center m-t-md">
              <img :src="qr" class="img-thumbnail" />
            </div>
            <h3 class="mt-20">
              3.
              <small>Back up your Secret Key.</small>
            </h3>
            <div class="form-group">
              <label for="factor">Security Key</label>
              <input
                id="factor"
                type="factor"
                v-model="secret"
                class="form-control"
                placeholder="Loading..."
              />
              <p class="mt-20">
                Please save this Key on paper. This Key will allow you to
                recover your Google Authentication in case of phone loss.
              </p>
              <p class="text-danger">
                Resetting your Google Authentication requires opening a support
                ticket and takes at least 7 days to process.
              </p>
            </div>
            <h3 class="mt-20">
              4.
              <small
                >Enter the 6 digit authentication code provided by Google
                Authenticator.</small
              >
            </h3>
            <form @submit.prevent="enabletwofactor" class="text-center">
              <div class="form-group">
                <label for="factor">Authentication code</label>
                <input
                  id="factor"
                  type="factor"
                  v-model="factor"
                  class="form-control"
                  placeholder="6-digit authentication code"
                />
              </div>
              <button
                v-if="!factor"
                class="btn btn-default btn-block"
                disabled=" "
              >
                Enable 2FA
              </button>
              <button v-else class="btn btn-accent btn-block text-accent">
                Enable 2FA
              </button>
            </form>
          </div>
        </div>
        <div class="panel-body" v-else>
          <h3 class="text-center">
            Status :
            <span class="text-accent">ENABLED</span>
          </h3>
          <div class="alert alert-disable m-t-xl" role="alert">
            <span class="fad fa-2x fa-exclamation-triangle alert-icon"></span>
            <div class="alert-content">
              Disabling two-factor authentication will reset your secret key and
              delete all of your API keys.
            </div>
          </div>
          <form @submit.prevent="resettwofa" class="text-center">
            <div class="form-group">
              <label for="factor">Authentication code</label>
              <input
                id="factor"
                type="factor"
                v-model="factor"
                class="form-control"
                placeholder="6-digit authentication code"
              />
            </div>
            <button
              v-if="!factor"
              class="btn btn-default btn-block"
              disabled=" "
            >
              Disable 2FA
            </button>
            <button v-else class="btn btn-accent btn-block text-accent">
              Disable 2FA
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import user from "@/api/user";
import nativeToast from "native-toast";

export default {
  name: "security",
  data() {
    return {
      factor: null,
      status2fa: null,
      secret: null,
      qr: null
    };
  },
  methods: {
    ...mapActions(["setSecure"]),
    twofactor() {
      user
        .twofactor()
        .then(response => {
          this.status2fa = response.data.status;
          this.secret = response.data.secret;
          this.qr = response.data.qr;
        })
        .catch(() => {
          //this.$store.dispatch("Logout", null);
        });
    },
    enabletwofactor() {
      user
        .enable2fa({
          twofa: this.factor
        })
        .then(response => {
          nativeToast({
            message: response.data.message,
            position: "top",
            timeout: 3000,
            type: "success"
          });

          this.setSecure(response.data.secure);
          this.factor = null;
          this.status2fa = true;
        })
        .catch(error => {
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error"
          });
          this.factor = null;
        });
    },
    resettwofa() {
      user
        .disable2fa({
          twofa: this.factor
        })
        .then(response => {
          nativeToast({
            message: response.data.message,
            position: "top",
            timeout: 3000,
            type: "success"
          });
          this.setSecure(response.data.secure);
          this.status2fa = false;
          this.factor = null;
          this.twofactor();
        })
        .catch(error => {
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error"
          });
          this.factor = null;
        });
    }
  },
  mounted() {
    this.twofactor();
  }
};
</script>

<style scoped>
.app {
  margin: 5px;
}
.alert-icon {
  vertical-align: top;
  margin-top: 5px;
}
.alert-disable {
  color: #949ba2;
  background-color: #494b54;
  border-color: #494b54;
}
.alert-content {
  margin-left: 16px;
  display: inline-block;
  width: calc(100% - 50px);
  text-align: left;
}
.cover {
  padding: 0 5px 55px 5px;
}
</style>
